var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-sheet',{staticClass:"ma-3",staticStyle:{"max-width":"1024px"}},[_c('os-sheet-content',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }